import { GrClose } from "react-icons/gr";
import { ProgressBar } from "../../components/ProgressBar";
import { Box } from "../../components/Box";
import {
  Breadcrumb,
  StaticBreadcrumb,
  Crumb,
  BreadcrumbDivider,
} from "../../components/Breadcrumbs";
import { Flex } from "../../components/Flex";
import { IconButton } from "../../components/IconButton";
import Topbar from "../../components/Topbar";
import { ROUTE } from "../../routes";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Button";
import { useDeleteMandate } from "../../data/useDeleteMandate";
import { queryClient } from "../../queryClient";
import { notify } from "../../utils/notify";
import { showError } from "../../utils/error-handling";
import { Modal } from "../../components/Modal";
import { useState } from "react";

export const NewChecksFrame = ({
  children,
  mandateId,
  step,
  showAddressStep,
  showMonitoringStep,
}: {
  children: any;
  step: "checks" | "individuals" | "address" | "monitoring" | "runchecks";
  mandateId?: number;
  showAddressStep?: boolean;
  showMonitoringStep?: boolean;
}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [doubleClickOnDelete, setDoubleClickOnDelete] = useState(false);

  const navigate = useNavigate();
  const { mutate: deleteMandate } = useDeleteMandate();

  const steps = (showAddressStep && !showMonitoringStep )
    ? ["checks", "individuals", "address", "runchecks"] 
    //: 
    // (showAddressStep && showMonitoringStep )? 
    // ["checks", "individuals","address","monitoring","runchecks"] :
    // (!showAddressStep && showMonitoringStep) ? 
    // ["checks", "individuals","monitoring","runchecks"]
    : ["checks", "individuals", "runchecks"];
  const progress = (steps.indexOf(step) + 1) * (100 / steps.length);

  const breadcrumbs = steps.map((currentStep, index) => ({
    isActive: step === currentStep,
    title: `${String(index + 1).padStart(2, "0")} ${
      {
        checks: "Select screening",
        individuals: "Add individuals",
        address: "Add address",
       // monitoring: "Monitoring",
        runchecks: "Run screening",
      }[currentStep]
    }`,
    key: index + 1,
  }));

  const handleDeleteCheck = () => {
    setDoubleClickOnDelete(true);
    deleteMandate(
      {
        id: mandateId,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["mandate"]);
          notify("Check deleted", {
            type: "success",
          });
          navigate(ROUTE.CHECKS);
        },
        onError: (err: any) => {
          showError(err, "A problem occurred while deleting the check.");
        },
      }
    );
  };

  return (
    <div>
      <Topbar
        header={
          <Flex justifyContent="space-between" width="100%">
            <>
              <Breadcrumb>
                <Breadcrumb.Section linkTo={ROUTE.CHECKS}>
                  Screening
                </Breadcrumb.Section>
                <Breadcrumb.Section>
                  Create a new screening record
                </Breadcrumb.Section>
              </Breadcrumb>
            </>
            <Flex>
              {mandateId && (
                <Button
                  variant="danger"
                  onClick={() => setIsDeleteModalOpen(true)}
                >
                  Cancel Check
                </Button>
              )}
              <IconButton
                Type={GrClose}
                onClick={() => navigate(ROUTE.CHECKS)}
                color="gray.40"
                ml={4}
                mr={3}
              />
            </Flex>
          </Flex>
        }
      ></Topbar>
      <Box height="calc(100vh - 155px)" overflowY="auto">
        <Box>
          <ProgressBar progress={progress} />
          <Box padding={2} marginLeft={2}>
            <StaticBreadcrumb>
              {breadcrumbs.map(({ isActive, title, key }, index) => (
                <Crumb
                  key={key}
                  isActive={isActive}
                  iconDivider={
                    index < breadcrumbs.length - 1 && <BreadcrumbDivider />
                  }
                >
                  {title}
                </Crumb>
              ))}
            </StaticBreadcrumb>
          </Box>
        </Box>
        <Flex justifyContent="center" alignItems="center">
          <Box>{children}</Box>
        </Flex>
      </Box>
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title="Do you want to delete this?"
        content="This is an irreversible action, all mandate and participant information will be permanently deleted. "
        onModalConfirmClick={handleDeleteCheck}
        secondaryButtonText="Cancel"
        primaryButtonText="Delete"
        primaryButtonVariant="danger"
        hasSecondaryButton
        width="450px"
        doubleClick={doubleClickOnDelete}
      />
    </div>
  );
};
